import React from "react";
import { Toggle } from "../components/Toggle";
import { setCommsProduct } from "../lib/api";
import type { AuthHeaders } from "../lib/auth";
import type { Me } from "../lib/types";
import { Card, Page } from "../design";

export function Communications({
  me,
  authHeaders,
  refresh,
  hideHeader,
}: {
  me: Me;
  authHeaders: AuthHeaders;
  refresh: () => Promise<void>;
  hideHeader?: boolean;
}) {
  const subscribed = me.comms_product !== false;
  const [busy, setBusy] = React.useState(false);

  async function set(next: boolean) {
    setBusy(true);
    try {
      await setCommsProduct(authHeaders, next);
      await refresh();
    } finally {
      setBusy(false);
    }
  }

  const body = (
    <Card
      title="Email"
      info="Every email has an unsubscribe link; this page is the source of truth."
    >
      <div className="per-rows">
        <label className="per-row">
          <span className="per-row-text">
            <span className="per-row-title">Product updates</span>
            <span className="per-row-sub">
              New compression heuristics, model support and dashboard features,
              roughly twice a month.
            </span>
          </span>
          <Toggle
            checked={subscribed}
            disabled={busy}
            onChange={(v) => set(v)}
            ariaLabel="Product updates"
          />
        </label>
        <div className="per-row">
          <span className="per-row-text">
            <span className="per-row-title">Delivered to</span>
            <span className="per-row-sub mono">{me.email || "—"}</span>
          </span>
          <span className="ds-meta">Change it under Profile</span>
        </div>
      </div>
    </Card>
  );

  if (hideHeader) return body;
  return <Page title="Email preferences">{body}</Page>;
}
